import { render, staticRenderFns } from "./camilo.vue?vue&type=template&id=b15874f0&scoped=true"
import script from "./camilo.vue?vue&type=script&lang=ts"
export * from "./camilo.vue?vue&type=script&lang=ts"
import style0 from "./camilo.vue?vue&type=style&index=0&id=b15874f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15874f0",
  null
  
)

export default component.exports